/**
 * UI experience groups → API experienceLevel[] tokens.
 * Junior folds Amateur + Beginner + Junior (legacy URL tokens still work).
 */
export const EXPERIENCE_LEVEL_OPTIONS = [
  {
    label: 'Junior',
    tokens: ['Amateur', 'Beginner', 'Junior'],
  },
  {
    label: 'Mid',
    tokens: ['Mid-level'],
  },
  {
    label: 'Senior',
    tokens: ['Senior'],
  },
  {
    label: 'Expert',
    tokens: ['Expert'],
  },
];

/** Default experienceLevels array shape used by ProjectsBase / loadBriefs. */
export const DEFAULT_EXPERIENCE_LEVELS = [
  { type: 'Amateur', isChecked: false, label: 'Amateur' },
  { type: 'Beginner', isChecked: false, label: 'Beginner' },
  { type: 'Junior', isChecked: false, label: 'Junior' },
  { type: 'Mid-level', isChecked: false, label: 'Mid-level' },
  { type: 'Senior', isChecked: false, label: 'Senior' },
  { type: 'Expert', isChecked: false, label: 'Expert' },
];

export const isExperienceGroupChecked = (experienceLevels, option) => {
  if (!experienceLevels || !option) return false;
  return option.tokens.some((token) => {
    const level = experienceLevels.find((item) => item.type === token);
    return level && level.isChecked;
  });
};

/**
 * Toggle all tokens for a UI group. If any token is checked, clears the group;
 * otherwise checks every token in the group.
 */
export const toggleExperienceGroup = (experienceLevels, option) => {
  const currentlyChecked = isExperienceGroupChecked(experienceLevels, option);
  const nextChecked = !currentlyChecked;

  return experienceLevels.map((level) => {
    if (option.tokens.includes(level.type)) {
      return { ...level, isChecked: nextChecked };
    }
    return level;
  });
};
